/* Optional Shopify analytics bridge.
 * Strict allowlist: no name, date, phone, address, entered number, or result.
 */
(function () {
  "use strict";
  const eventMap = {
    "luvire:calculator-viewed": "calculator_viewed",
    "luvire:calculator-started": "calculator_started",
    "luvire:calculator-completed": "calculator_completed",
    "luvire:result-section-opened": "result_section_opened",
    "luvire:related-calculator-clicked": "related_calculator_clicked",
    "luvire:full-reading-cta-viewed": "full_reading_cta_viewed",
    "luvire:full-reading-cta-clicked": "full_reading_cta_clicked",
    "luvire:calculation-error": "calculation_error"
  };
  Object.keys(eventMap).forEach(function (domEvent) {
    document.addEventListener(domEvent, function (event) {
      const detail = event && event.detail ? event.detail : {};
      const calculatorKey = String(detail.calculator_key || "").slice(0, 80);
      const version = String(detail.algorithm_version || "").slice(0, 24);
      const placement = String(detail.placement || "standalone").slice(0, 40);
      const context = String(detail.event_context || "").slice(0, 80);
      if (!calculatorKey) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventMap[domEvent],
        calculator_key: calculatorKey,
        calculator_version: version,
        calculator_placement: placement,
        calculator_event_context: context
      });
    });
  });
}());
